import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import * as SVG from '~/assets/svg'
import { Header } from '~/components/header'
import { Sidebar } from '~/components/sidebar'
import * as route from '~/helper/constant/route'
import { AbstractReportsComponent, mapStateToProps } from './abstract'

class ReportsComponent extends AbstractReportsComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }
    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Sidebar id="report_accounting" isAccount={true} />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; &nbsp;</a>
                            </li>
                            <li>{t('reports:reports')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('reports:reports')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="folder-page">
                        <div className="row clearfix">
                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.transaction)}
                                >
                                    <a href={route.admin.accounting.reports.transaction} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.transaction} className="folder-name">
                                        {t('reports:transaction')}
                                        <span> {t('reports:viewtransaction')}</span>
                                    </a>
                                </div>
                            </div>

                            {/* <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.accountstatement)}
                                >
                                    <a href={route.admin.accounting.reports.accountstatement} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.accountstatement} className="folder-name">
                                        {t('reports:accountstatement')}
                                        <span> {t('reports:viewaccountstatement')}</span>
                                    </a>
                                </div>
                            </div> */}

                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.incomesummary)}
                                >
                                    <a href={route.admin.accounting.reports.incomesummary} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.incomesummary} className="folder-name">
                                        {t('reports:incomesummary')}
                                        <span> {t('reports:viewincomesummary')}</span>
                                    </a>
                                </div>
                            </div>

                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.expensesummary)}
                                >
                                    <a href={route.admin.accounting.reports.expensesummary} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.expensesummary} className="folder-name">
                                        {t('reports:expensesummary')}
                                        <span> {t('reports:viewexpensesummary')}</span>
                                    </a>
                                </div>
                            </div>

                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.incomeexpense)}
                                >
                                    <a href={route.admin.accounting.reports.incomeexpense} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.incomeexpense} className="folder-name">
                                        {t('reports:incomeexpense')}
                                        <span> {t('reports:viewincomeexpense')}</span>
                                    </a>
                                </div>
                            </div>

                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.taxsummary)}
                                >
                                    <a href={route.admin.accounting.reports.taxsummary} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.taxsummary} className="folder-name">
                                        {t('reports:taxsummary')}
                                        <span> {t('reports:viewtaxsummary')}</span>
                                    </a>
                                </div>
                            </div>
                            <div className="float-left course-your">
                                <div
                                    className="folder-list clearfix"
                                    onClick={() => (window.location = route.admin.accounting.reports.profitloss)}
                                >
                                    <a href={route.admin.accounting.reports.profitloss} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.profitloss} className="folder-name">
                                        {t('reports:profitloss')}
                                        <span> {t('reports:viewprofitloss')}</span>
                                    </a>
                                </div>
                            </div>
                            {/* <div className="float-left course-your">
                                <div className="folder-list clearfix" onClick={() => (window.location = route.admin.accounting.reports.productstockreport)}>
                                    <a href={route.admin.accounting.reports.productstockreport} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.reports.productstockreport} className="folder-name">
                                        {t('reports:productstock')} 
                                        <span> {t('reports:viewproductstock')}</span>
                                    </a>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const Reports = withTranslation()(connect(mapStateToProps)(ReportsComponent))

export { Reports }
